<template>
  <div id="app">
    <router-view />
    <BottomNav />
    <ChatWidget />
    <WalletModal />
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'
import ChatWidget from '@/components/ui/ChatWidget.vue'
import WalletModal from '@/components/WalletModal.vue'

export default { components: { BottomNav, ChatWidget, WalletModal } }
</script>

<style>
html, body, #app { width: 100%; min-height: 100%; overflow-x: hidden; }
</style>
